export default "__VITE_ASSET__DyJPVSJ3__"